(function () {
  'use strict';

  var header = document.querySelector('[data-header-section]');

  if (header) {
    var updateHeader = function () {
      if (window.pageYOffset > 12) {
        header.classList.add('lust-header--scrolled');
      } else {
        header.classList.remove('lust-header--scrolled');
      }
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  var revealItems = document.querySelectorAll('[data-lust-reveal]');

  if (!revealItems.length) {
    return;
  }

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(revealItems, function (item) {
      item.classList.add('lust-is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lust-is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  Array.prototype.forEach.call(revealItems, function (item) {
    observer.observe(item);
  });
})();
